import React, { useState } from "react";
import {
  WhiteButton,
  YellowButton,
} from "../../components/UI/Button/button";
import { LocationIcon } from "../../constants/svg";
import classes from "./landingJobDetails.module.css";
import Twitter from "../../assets/images/JobsDetails/twitter.svg";
import Instagram from "../../assets/images/JobsDetails/instagram.svg";
import Facebook from "../../assets/images/JobsDetails/facebook.svg";
import Website from "../../assets/images/JobsDetails/website.svg";
import Share from "../../assets/images/JobsDetails/share.svg";
import { StanThumbUp } from "../../constants/stan";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import Header from "../../components/Landing/Header/header";
import Footer from "../../components/Landing/Footer/footer";
import { currencyFormat } from "../../utils/functions";
import { DocumentHeader } from "../../components/Seo";

const SignUpModal = ({ showModal }) => {
  const navigate = useNavigate();
  const handleSignUp = () => {
    navigate("/register?tab=talent");
    showModal(false);
  };

  return (
    <div className={classes.bg}>
      <div className={`${classes.modal}`}>
        <div className="flex relative center">
          <span className="center-flex" onClick={() => showModal(false)}>
            x
          </span>
          <StanThumbUp shirtColor={`#030659`} />
          <h3 className={classes.modalHeader}>You are not signed in</h3>
          <p className="mt-sm mb-md">Please Create an Account</p>
          <YellowButton onClick={handleSignUp}>Create Account</YellowButton>
        </div>
      </div>
    </div>
  );
};

const JobDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [modal, showModal] = useState(false);
  const job = state?.job;

  const handleApplication = (e) => {
    e.preventDefault();
    showModal(true);
  };

  if (!job) return <div>Loading...</div>;

  return (
    <>
      <DocumentHeader
        title={job.title ? `${job.title}${job.location ? ` — ${job.location}` : ""}` : "Job details"}
        description={job.description || undefined}
      />
      <Header />
      {modal && <SignUpModal showModal={showModal} />}
      <div className={classes.parent}>
        <div className={`flex ${classes.between} ${classes.info} ${classes.column}`}>
          <div className={`flex ${classes.info} ${classes.column}`}>
            <div className={`center-flex ${classes.picture}`}>
              <span>{job.title?.charAt(0) || "A"}</span>
            </div>
            <div>
              <h3>{job.title}</h3>
              <p className="mt-sm mb-sm">{job.jobType}</p>
              <p className={`flex ${classes.info}`}>
                <LocationIcon /> {job.location}
              </p>
            </div>
          </div>
          <div className="mt-sm">
            <button className={classes.rightLink}>View company profile</button>
            <div className={`flex mt-sm ${classes.links} ${classes.info}`}>
              <img src={Share} alt="Share" />
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer">
                <img src={Instagram} alt="Instagram" />
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noreferrer">
                <img src={Twitter} alt="Twitter" />
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
                <img src={Facebook} alt="Facebook" />
              </a>
              <a href="https://www.example.com" target="_blank" rel="noreferrer">
                <img src={Website} alt="Website" />
              </a>
            </div>
          </div>
        </div>
        <div className={`mt-md mb-md ${classes.hrRule}`} />
        <div className={classes.gap}>
          <div className={`flex ${classes.between} ${classes.column}`}>
            <div>
              <h3 className="capitalise">
                {job.title} {job.provideOneMonthNotice === "Yes" ? "(1yr guarantee)" : ""}
              </h3>
              <p className={classes.subtxt}>
                ({job.duration}) {job.startDate && moment(job.startDate).format("MMM yyyy")} - 
                {job.endDate ? moment(job.endDate).format("MMM YYYY") : "Present"}
              </p>
              <p className={classes.subtxt}>
                {job.workMode} {" | "}
                {job.location}
              </p>
            </div>
            <h3 className={classes.right}>
              ₦{currencyFormat(Number(String(job?.budget ?? '').replace(/\D/g, '') || 0))} pm
            </h3>
          </div>
          <div className={`flex mt-sm ${classes.between} ${classes.column}`}>
            <div className={`flow ${classes.objective}`}>
              <h4>Description</h4>
              <p>{job.description}</p>
            </div>
          </div>
          <div className={`flex mt-sm ${classes.between} ${classes.column}`}>
            <div className={`flow ${classes.objective}`}>
              <h4>Acceptance Criteria</h4>
              <p>{job.acceptanceCriteria}</p>
            </div>
          </div>
          <div className={`flex mt-sm ${classes.between} ${classes.column}`}>
            <div className={`flex ${classes.skillObjective}`}>
              <h4>Skills</h4>
              {job.skillsAndRequirements?.map((item, idx) => (
                <p key={idx}>{item}</p>
              ))}
            </div>
          </div>
          <div className={`flex mt-sm ${classes.between} ${classes.column}`}>
            <div className={`flow ${classes.objective}`}>
              <h4>Objectives</h4>
              <p>{job.objectives}</p>
            </div>
          </div>
        </div>
        <div className={`flex mt-md ${classes.btn}`}>
          <WhiteButton onClick={() => navigate(-1)}>Cancel</WhiteButton>
          <YellowButton onClick={handleApplication}>
            Apply Now
          </YellowButton>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JobDetails;